import _Set from "@babel/runtime-corejs3/core-js-stable/set";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import Ajv from 'ajv';
let SchemaValidator = function () {
  function SchemaValidator(schema, ajvOptions = {
    allErrors: false
  }) {
    _classCallCheck(this, SchemaValidator);
    this.ajv = new Ajv(ajvOptions);
    this.validator = this.ajv.compile(schema);
  }
  _createClass(SchemaValidator, [{
    key: "getUniqueErrors",
    value: function getUniqueErrors() {
      const errorMessageArray = this.ajv.errorsText(this.validator.errors).split(', ');
      return [...new _Set(errorMessageArray)].join('\n');
    }
  }, {
    key: "validate",
    value: function validate(data) {
      const valid = this.validator(data);
      const errorMessages = valid ? undefined : this.getUniqueErrors();
      return {
        valid,
        errorMessages
      };
    }
  }]);
  return SchemaValidator;
}();
export { SchemaValidator as default };